import { z } from 'zod';

import { requiredEmailFieldSchema } from '@src/features/customers/auth/core/requiredEmailFieldSchema';
import type { Translate } from '@src/i18n/useTranslate';

export const passwordLoginSchema = (t: Translate['i18n']) => {
  const requiredMessage = t('checkout_auth_required_field');

  return z.object({
    email: requiredEmailFieldSchema(t),
    password: z.string().min(1, requiredMessage),
  });
};

export type PasswordLoginFormValues = z.infer<ReturnType<typeof passwordLoginSchema>>;
